import React, { memo } from 'react'
import Icon from '../../core/Icon/ContentfulIcon'

import { IIcon } from 'contentful-types'

type IconProps = {
  icon: IIcon
}

const MemoIcon = ({ icon }: IconProps) => {
  return <Icon {...icon} />
}

export default memo(MemoIcon)
